module.exports = __webpack_public_path__ + "static/img/qrcode4.fa70e2bf.jpg";